import React from 'react'

const BottomBlock = () => {

  return (
    <div>
        <div className='block bottomContainer'  style={{width: "100%"}}>
            <span className='bottom'>
                <div className='imgHover'>
                <img className="" src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/feature_icon_2.png" data-src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/feature_icon_2.png" height="60" width="60" alt="Service"/>
                </div>
                <div>
                    <h1>STEP 1: COMPLETE PROFILE</h1>
                    <p>Once you are approved, we showcase you to leading Indian technology startups</p>
                </div>
            </span>
            <span className='bottom'>
                <div className="imgHover">
                <img className="icon-2" src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/icon1.png" data-src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/icon1.png" height="60" width="60" alt="Service"/>
                </div>
                <div className="services-description">
                    <h1>Step 2: Receive Job Offers</h1>
                    <p>Companies start sending interview requests. Talk to only the ones you like.</p>
                </div>
            </span>
            <span className='bottom'>
                <div className="imgHover">
                <img className="icon-3" src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/icon2.png" data-src="https://d383au3bye3rv1.cloudfront.net/static/images/optimized/icon2.png" height="60" width="60" alt="Service"/>
                </div>
                <div>
                    <h1>Step 3: Accept Dream Job</h1>
                    <p>Compare your offers and accept the best one.<br></br> Hired!</p>
                </div>
            </span>
        </div>
        <hr />
        <div className='block bottomContainer bottomDetails'  style={{width: "100%"}}>
            <span className='bottom numericData' style={{textAlign:"center", color:"#143FCD"}}>
                <div style={{fontSize: "40px"}}>130K+</div>
                <div style={{fontSize: "26px", marginTop:"12px"}}>Tech Jobs</div>
            </span>
            <span className='bottom numericData' style={{textAlign:"center", color:"#F0591C"}}>
            <div style={{fontSize: "40px"}}>60,00,000</div>
                <div style={{fontSize: "26px", marginTop:"12px"}}>Matches Made</div>
            </span>
            <span className='bottom' style={{textAlign:"center", color:"#0C7134"}}>
                <div style={{fontSize: "40px"}}>8M+</div>
                <div style={{fontSize: "26px", marginTop:"12px"}}>Startups-Ready Candidates</div>
            </span>
        </div>
        <hr />
    </div>
  )
}

export default BottomBlock